import {QuizConfig} from '@/global/types/quiz';
import quiz from '@/quiz/equipment'

const TAG_VIRTUAL_WORKER = "virtual";
const TAG_NON_VIRTUAL_WORKER = "non-virtual";

const equipment: QuizConfig = {
    options: quiz.options,
    types: quiz.types,
    pages: [
        {
            id: null,
            allowedVersion: ["1.0", "1.1"],
            title: "title",
            description: {
                "description.default": true,
                "description.virtualworker": {
                    stylistTags: [TAG_VIRTUAL_WORKER]
                }
            },
            align: {
                title: "center",
                description: "left",
                text: "left",
                info: "left",
                afterComponents: "left"
            },
            afterComponents: {
                "afterComponents.beforeSelection": [{
                    country: [null]
                }, {
                    SETTINGS_autologin: false
                }],
                "afterComponents.limitedSelection": [{
                    "__function:_quiz_conditions_isLimitedCountry": true
                }, {
                    SETTINGS_autologin: false
                }],
                "afterComponents.allowedSelection": [{
                    country: true
                }, {
                    SETTINGS_autologin: false
                }],
                "afterComponents.autoLoginBeforeSelection": [{
                    country: [null]
                }, {
                    SETTINGS_autologin: true
                }],
                "afterComponents.autoLoginLimitedSelection": [{
                    "__function:_quiz_conditions_isLimitedCountry": true
                }, {
                    SETTINGS_autologin: true
                }],
                "afterComponents.autoLoginAllowedSelection": [{
                    country: true
                }, {
                    SETTINGS_autologin: true
                }]
            },
            components: [{
                name: "country"
            }],
        }
    ],
    components: {
        country: {
            type: 'dropdown',
            wrapperCssClass: 'offset-md-3 col-md-6',
            options: {
                source: 'store',
                target: 'db/countries/items',
                value: 'alpha3',
                name: 'name',
                filter: 'quiz_filter_countries'
            },
            validation: {
                required: true
            },
            payload: {
                field: 'country'
            }
        }
    }
}

export default equipment;